import { imageUrl } from '@helpers/image';
import { withBaseProps } from '@hoc/withBaseProps';
import { ButtonType } from '@stories/Components/Buttons/Button/ButtonType';
import CallButton from '@stories/Components/Buttons/CallButton/CallButton';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './HeaderReduced.styles';
const HeaderReduced = ({ buttonCta, contactCta, logo, showCtasBasedOnOpeningHours, isOpen }) => {
    const showWhenOpen = !showCtasBasedOnOpeningHours || (showCtasBasedOnOpeningHours && isOpen);
    const showWhenClosed = !showCtasBasedOnOpeningHours || (showCtasBasedOnOpeningHours && !isOpen);
    const hasMobileContact = showWhenOpen && contactCta;
    const containerClass = hasMobileContact ? '' : 'no-mobile-contact';
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { className: containerClass },
            React.createElement(S.Inner, null,
                logo && (React.createElement(S.LogoWrapper, { href: "/" },
                    React.createElement(S.Logo, { alt: logo.altText, loading: "eager", src: imageUrl(logo, { width: 145, heightratio: 99 / 145 }), width: "145", height: "99" }))),
                React.createElement(S.RightWrapper, null,
                    showWhenOpen && contactCta && (React.createElement(S.ContactWrapper, null,
                        React.createElement(CallButton, { ...contactCta }))),
                    showWhenClosed && buttonCta && (React.createElement(S.CtaWrapper, null,
                        React.createElement(LinkButton, { buttonType: ButtonType.Default, href: buttonCta.url, target: buttonCta.target }, buttonCta.text))))),
            showWhenOpen && contactCta && (React.createElement(S.MobileContactWrapper, null,
                React.createElement(CallButton, { ...contactCta }))))));
};
export default withBaseProps(HeaderReduced);
